import type { ComponentType } from "react";
import type React from "react";
import { useContext } from "react";

import type { ECategoryLeadersMetricType } from "../../CategoryLeaders.types";
import { CategoryLeadersContext } from "../CategoryLeadersContext/CategoryLeadersContext";
import { CategoryLeadersTable } from "../CategoryLeadersTable/CategoryLeadersTable";
import { CategoryLeadersTableTop } from "../CategoryLeadersTable/CategoryLeadersTableTop/CategoryLeadersTableTop";
import type { ICategoryLeadersTableTopProps } from "../CategoryLeadersTable/CategoryLeadersTableTop/CategoryLeadersTableTop.types";

import { CategoryLeadersPageWrapper } from "./CategoryLeadersPage.styles";

interface ICategoryLeadersPageProps {
    metricType: ECategoryLeadersMetricType;
    TableHeaderComponent?: ComponentType<ICategoryLeadersTableTopProps>;
}

export const CategoryLeadersPage: React.FunctionComponent<ICategoryLeadersPageProps> = (props) => {
    const { metricType, TableHeaderComponent = CategoryLeadersTableTop } = props;
    const { services } = useContext(CategoryLeadersContext);

    const params = services?.navigator.getParams() as any;

    return (
        <CategoryLeadersPageWrapper>
            <CategoryLeadersTable
                services={services}
                navParams={params}
                metricType={metricType}
                HeaderComponent={TableHeaderComponent}
            />
        </CategoryLeadersPageWrapper>
    );
};
